import { QUERY_PRESETS } from "@/queries/queryTimeConfig";

export const roomInventoryConfig = {
  getRoomInventory: {
    key: "getRoomInventory",
    url: "/api/v1/room-inventory",
    method: "GET",
    options: {
      ...QUERY_PRESETS.LIST,
    },
  },
};
